import { render, staticRenderFns } from "./bill-yf-list.vue?vue&type=template&id=074f38e1"
import script from "./bill-yf-list.vue?vue&type=script&lang=js"
export * from "./bill-yf-list.vue?vue&type=script&lang=js"
import style0 from "./bill-yf-list.vue?vue&type=style&index=0&id=074f38e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports